import { Route, Switch } from 'wouter';
import { Landing } from './routes/Landing.js';
import { Login } from './routes/Login.js';
import { AuthCallback } from './routes/AuthCallback.js';
import { Dashboard } from './routes/Dashboard.js';
import { ContestNew } from './routes/ContestNew.js';
import { ContestScan } from './routes/ContestScan.js';
import { ContestConfirm } from './routes/ContestConfirm.js';
import { ContestQuestions } from './routes/ContestQuestions.js';
import { ContestAnalyzing } from './routes/ContestAnalyzing.js';
import { ContestResult } from './routes/ContestResult.js';
import { ContestPreview } from './routes/ContestPreview.js';
import { Privacy, Terms } from './routes/LegalPages.js';
import { NotFound } from './routes/NotFound.js';

export function App() {
  return (
    <Switch>
      <Route path="/" component={Landing} />
      <Route path="/login" component={Login} />
      <Route path="/auth/callback" component={AuthCallback} />
      <Route path="/dashboard" component={Dashboard} />
      <Route path="/contest/new" component={ContestNew} />
      <Route path="/contest/:id/scan">{(params) => <ContestScan id={params.id} />}</Route>
      <Route path="/contest/:id/confirm">{(params) => <ContestConfirm id={params.id} />}</Route>
      <Route path="/contest/:id/questions">{(params) => <ContestQuestions id={params.id} />}</Route>
      <Route path="/contest/:id/analyzing">{(params) => <ContestAnalyzing id={params.id} />}</Route>
      <Route path="/contest/:id/result">{(params) => <ContestResult id={params.id} />}</Route>
      <Route path="/contest/:id/preview">{(params) => <ContestPreview id={params.id} />}</Route>
      {/* Phase 2: detail view routes to result if analysis exists, else to confirm.
          Phase 4 will replace with a proper detail screen (timeline, documents, hearings). */}
      <Route path="/contest/:id">{(params) => <ContestConfirm id={params.id} />}</Route>
      <Route path="/privacy" component={Privacy} />
      <Route path="/terms" component={Terms} />
      <Route component={NotFound} />
    </Switch>
  );
}
